import { ReelWin } from "./ReelWin";

// import { betValueGlobal } from "../config/GlobalVariableConfig";

import { spinData /*, WinObject*/ } from '../server/getServerResposesFun';


import { RespinIndex } from "../config/GlobalVariableConfig";

// import { Manager } from "../core/Manager";

import {
    REEL_NUMBERS,
} from "../config/reelConfig";
// import { sound } from "@pixi/sound";
import { EventEmitter } from "pixi.js";
import { casinoEventEmitter } from "../core/CasinoChannelHandler";

export const reelSpinEmitter = new EventEmitter();

export class Reels extends ReelWin {

    // private uiReel: Ui;
    // private sessionId: string;
    // private multTotalValue1: Text;

    constructor() {
        super();

    }

    public update() {

        this.updateReelWin()
    }

    public setReelRunning(val: boolean) {
        this.running = val;
    }

    private resetReelRunning(spinStype: string) {
        this.running = true;

        if (spinStype === "BASE") {
            console.log("inside resetReelRunning Base")
            RespinIndex.reset();
        }


        console.log("currentRespinIndex", RespinIndex.value, spinStype);

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            this.allReelArray[reelNum].container.visible = true;
        }

        this.reelOverlayContainer.removeChildren();
        this.reelOverlayContainer.destroy();
        this.initReelOverlayContainer();

    }


    public async startPlay(spinStype: string): Promise<[number, number, number?]> {

        // if (!spinData.dataFeatched) {
        //     await this.waitForData();
        // }

        // Cleanup any existing listeners for 'betDeclined' before adding a new one
        casinoEventEmitter.removeAllListeners('betDeclined');

        // Create a promise that resolves when 'betDeclined' is emitted
        const betDeclinedPromise = new Promise((resolve) => {
            // 'once' ensures automatic cleanup after the event is handled
            casinoEventEmitter.once('betDeclined', () => resolve('BetDeclined'));
        });

        console.log("startPlay for Freegame", this.running, spinStype, RespinIndex.value, spinData.respins.length);

        if (this.running) {
            return [0, 0];
        }


        // if (spinStype === "BASE") {
        //     this.fetchSpinResponse();  // note: no await here
        // }

        this.resetReelRunning(spinStype);

        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;

        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_enter") {
                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                console.log(`feature_enter triggered: ${freeGameTrigger}`);
                this.running = false;

                const accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                RespinIndex.increase();

                return [freeGameTrigger, accumulatedsWinAmount];
            }
            else if (respinType === "feature_exit" || respinType === "max_win_reached") {
                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                this.running = false;
                RespinIndex.increase();


                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];
            }
            else if (respinType === "reveal" || respinType === "collapse" || respinType === "fs_reveal" || respinType === "fs_collapse") {

                // await new Promise(resolve => setTimeout(resolve, 200));

                // if (respinType === "fs_reveal") {
                //     Manager.casinoChannelHandler.reportFeatureRoundStarted();
                //     const fsRevealPosition = fsRevealIndexes.length - fsRevealIndexes.indexOf(currentRespinIndex) - 1;
                //     Manager.casinoChannelHandler.reportUpdateFeatureCounter(fsRevealPosition);
                // }




                if (RespinIndex.value > 0) {
                    // await this.putRandomWild(RespinIndex.value);
                    await this.cacadingReels(RespinIndex.value);
                    // await new Promise(resolve => setTimeout(resolve, 2000));
                }


                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal");


                if (!isNewSpin) {
                    reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value - 1].respinMultiplier);
                    reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value - 1].surgeMeter);
                }
                // if (respinType === "reveal") {
                //     reelSpinEmitter.emit('updateMultiplier', 0);
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }
                // else if (respinType === "fs_reveal") {
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }

                // Race between the reels and the 'betDeclined' event
                const betPromiseResult = await Promise.race([
                    this.startReels(RespinIndex.value, isNewSpin, spinStype), // Reel logic
                    betDeclinedPromise, // Event bet decline
                ]);

                if (betPromiseResult === 'BetDeclined') {
                    console.log('Bet was declined, breaking out of startPlay.');
                    this.resetReelRunning(spinStype);

                    this.reelMove1CompletePromise.then(() => {
                        this.resetSymbolPositions();
                    })

                    return [0, -1];
                }

                // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value].respinMultiplier);
                // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value].surgeMeter);

                // await this.addWildMultIntoMeter(RespinIndex.value);

                await this.animateWinningSymbols(RespinIndex.value); // this is just marking the winning symbol, not animating symbols here

                // update the global multiplier value & surge-meter



                // if (/*RespinIndex.value > 0 &&*/ spinData.respins[RespinIndex.value].multiplier > 1) {
                //     this.setMultValue(spinData.respins[RespinIndex.value].multiplier);
                // }

                await this.lineToggle(RespinIndex.value); // this is actual function that animates symbols


                // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value].respinMultiplier);
                // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value].surgeMeter);

                // if (spinData.respins[RespinIndex.value].winAmount > 0) {
                //     this.resetNonwinSymbols();
                // }

                if (isNewSpin) {
                    respinWin = 0;
                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;


                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                // Check for fs_collapse sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_collapse") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "fs_collapse") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {

                    this.running = false;
                    RespinIndex.increase();

                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }


            }

            RespinIndex.increase();
            console.log(`Respin is done for index ${RespinIndex.value}`);

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }





    // private async fetchSpinResponse() {

    //     await spinResponse();

    //     // this.dataFeatched = true;

    //     // if (!this.uiReel.autoPlayActive) // normal play
    //     // {
    //     //     this.uiReel.slam.visible = true;
    //     //     // this.ui.spin.visible = false;
    //     //     this.uiReel.visibilityOffSpinButtons();
    //     // }

    //     // this.uiReel.slam.alpha = 0.9;

    //     console.log("Data fetched and updated.");
    //     console.log(spinData);
    // }


    // private tweenAccWinValue: Tween<{ x: number }>;



    // private setAccWinValue(val: number) {
    //     // this.creditValue.text =  val.toFixed(2);

    //     const accWinValueWidth: number = 430;

    //     if (val === 0) {
    //         this.tweenAccWinValue?.stop();
    //         this.accWinValue.text = "";
    //     }
    //     else {

    //         const animate: boolean = Number(this.accWinValue.text) === 0 ? false : true;

    //         if (animate) {

    //             let previousWidth = this.accWinValue.width; // Track the previous width

    //             let currentVal: number = Number(this.accWinValue.text);
    //             this.tweenAccWinValue = new Tween({ x: currentVal }, tweenGroup)
    //                 .to({ x: val }, 500)
    //                 .onUpdate((object) => {
    //                     currentVal = object.x; // Update currentVal with the tweened value
    //                     this.accWinValue.text = currentVal.toFixed(2);

    //                     // Only apply scaling if the width has changed
    //                     if (this.accWinValue.width > previousWidth) {
    //                         this.accWinValue.scale = 1;
    //                         const scale = Math.min(accWinValueWidth / this.accWinValue.width, 1);
    //                         this.accWinValue.scale.set(scale, scale); // Apply scaling

    //                         // Update the previous width after scaling
    //                         previousWidth = this.accWinValue.width;
    //                     }

    //                 })
    //                 .onComplete(() => {
    //                     tweenGroup.remove(this.tweenAccWinValue);
    //                     this.accWinValue.text = val.toFixed(2);

    //                     this.accWinValue.scale = 1;
    //                     const scale = Math.min(accWinValueWidth / this.accWinValue.width, 1);
    //                     this.accWinValue.scale.set(scale, scale); // Apply scaling

    //                 })
    //                 .start();

    //         }
    //         else {
    //             this.accWinValue.text = val.toFixed(2);

    //             this.accWinValue.scale = 1;
    //             const scale = Math.min(accWinValueWidth / this.accWinValue.width, 1);
    //             this.accWinValue.scale.set(scale, scale); // Apply scaling
    //         }
    //     }



    // }




    // private setMultValue(val: number) {
    //     // Remove the "x" at the end of the current value and convert it to a number
    //     const currentText = this.multTotalValue.text.replace('x', '');
    //     const animate: boolean = true;//Number(currentText) === 0 ? false : true;

    //     if (animate) {
    //         let currentVal: number = Number(currentText); // Convert to number without "x"
    //         const tween = new Tween({ x: currentVal }, tweenGroup)
    //             .to({ x: val }, 500)
    //             .onStart(() => {
    //                 if (val > Number(currentText)) {
    //                     // this.multFXSpine.state.setAnimation(0, "animation", false);
    //                     sound.play('mult_to_meter');
    //                 }
    //             })
    //             .onUpdate((object) => {
    //                 currentVal = object.x; // Update currentVal with the tweened value
    //                 this.multTotalValue.text = `${currentVal.toFixed(0)}x`;
    //             })
    //             .onComplete(() => {
    //                 tweenGroup.remove(tween);
    //                 this.multTotalValue.text = `${val.toFixed(0)}x`;
    //                 this.multTotalValue.text = `${currentVal.toFixed(0)}x`;
    //             })
    //             .start();
    //     }
    //     else {
    //         // Directly update the text with the new value, including the "x"
    //         this.multTotalValue.text = `${val.toFixed(0)}x`;
    //     }
    // }

}